/* Bange product cards — swatch interaction (2026-10-07) */
(function () {
  'use strict';

  if (window.__bangeProductCardsInitialized) return;
  window.__bangeProductCardsInitialized = true;

  function selectSwatch(swatch, event) {
    if (!swatch) return;

    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    var card = swatch.closest('[data-bange-product-card]');
    if (!card) return;

    var variantId = swatch.getAttribute('data-variant-id');
    var variantUrl = swatch.getAttribute('data-variant-url');
    var onSale = swatch.getAttribute('data-on-sale') === 'true';
    var price = swatch.getAttribute('data-price') || '';
    var comparePrice = swatch.getAttribute('data-compare-price') || '';
    var promoText = swatch.getAttribute('data-promo-text') || '';

    card.querySelectorAll('[data-bange-swatch]').forEach(function (item) {
      var selected = item === swatch;
      item.classList.toggle('is-selected', selected);
      item.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });

    var hasVariantImage = false;
    card.querySelectorAll('[data-bange-swatch-image]').forEach(function (image) {
      var selected = image.getAttribute('data-variant-id') === variantId;
      image.classList.toggle('is-selected', selected);
      if (selected) hasVariantImage = true;
    });

    card.classList.toggle('bange-product-card--variant-selected', hasVariantImage);

    if (variantUrl) card.setAttribute('href', variantUrl);

    var currentPrice = card.querySelector('[data-bange-current-price]');
    if (currentPrice && price) {
      currentPrice.textContent = price;
      currentPrice.classList.toggle('bange-product-card-current-price--sale', onSale);
    }

    var compare = card.querySelector('[data-bange-compare-price]');
    if (compare) {
      compare.textContent = onSale ? comparePrice : '';
      compare.classList.toggle('bange-product-card-hidden', !onSale);
    }

    var promo = card.querySelector('[data-bange-promo-tag]');
    if (promo) {
      promo.textContent = onSale ? promoText : '';
      promo.classList.toggle('bange-product-card-hidden', !onSale);
    }
  }

  document.addEventListener('click', function (event) {
    var swatch = event.target.closest('[data-bange-swatch]');
    if (!swatch) return;
    selectSwatch(swatch, event);
  }, true);

  document.addEventListener('keydown', function (event) {
    var swatch = event.target.closest('[data-bange-swatch]');
    if (!swatch || (event.key !== 'Enter' && event.key !== ' ')) return;
    selectSwatch(swatch, event);
  }, true);
})();
